import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=adeadd88&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=ts"
export * from "./ContactForm.vue?vue&type=script&lang=ts"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=adeadd88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adeadd88",
  null
  
)

export default component.exports